export enum Vsco {
  APP_STORE_ID = '588013838',
  COLLECTION_ID = '53ea97c07567085b548b49c0',
  SITE_ID = 113950,
  USERNAME = 'vsco',
}
